import type { QuestionDto, QuestionInputDto, QuestionPagedRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class QuestionService {
  apiName = 'Default';
  

  createQuestionByInputDto = (inputDto: QuestionInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, QuestionDto>({
      method: 'POST',
      url: '/api/app/question/question',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteQuestionByQuestionId = (questionId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/question/question/${questionId}`,
    },
    { apiName: this.apiName,...config });
  

  editQuestionByInputDto = (inputDto: QuestionInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/question/edit-question',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllQuestionsByInput = (input: QuestionPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<QuestionDto>>({
      method: 'GET',
      url: '/api/app/question/questions',
      params: { content: input.content, type: input.type, state: input.state, questionGroupId: input.questionGroupId, isCommon: input.isCommon, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getQuestionByQuestionId = (questionId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, QuestionDto>({
      method: 'GET',
      url: `/api/app/question/question/${questionId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
